import { render, staticRenderFns } from "./textlist.vue?vue&type=template&id=b8a0502c&"
import script from "./textlist.vue?vue&type=script&lang=js&"
export * from "./textlist.vue?vue&type=script&lang=js&"
import style0 from "./textlist.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports